import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'w-full',
    header: 'mb-3 flex justify-between gap-1 sm:mb-4',
    subHeader: 'mb-3 flex justify-between gap-1 max-sm:flex-col sm:mb-4',
    author: 'heading-m-bold flex items-center gap-3',
    date: 'heading-xs text-secondary-hover',
    authorInfo: 'heading-xs',
    content: 'flex flex-col gap-3',
    gallery: 'mb-4',
    imageButton: 'size-16 cursor-pointer',
    image: 'size-16 object-cover',
    carousel: '[--slide-size:auto] [--slide-spacing:4px]',
    service: 'h-5 w-auto',
    sourceBlock: 'mt-6 flex items-center gap-8 underline underline-offset-4',
    showMoreLink: 'hover:text-blue block transition-colors',
    sourceLink: 'mt-1 block'
  }
});
